// Shared section chrome for the preprocess (FORECAST QUESTION / RESOLVES) panel and the
// trigger popup that borrows its look.

import { C } from "./colors.js";

export const SECTION_LABEL_STYLE = {
  fontSize: 12,
  color: C.purpleL,
  letterSpacing: 0.6,
};

export const SECTION_EDIT_STYLE = {
  background: "transparent",
  border: "none",
  padding: 0,
  color: C.purpleL,
  fontSize: 12,
  fontWeight: "bold",
  letterSpacing: 0.6,
  textTransform: "uppercase",
  cursor: "pointer",
  whiteSpace: "nowrap",
};

export const SECTION_RULE = { height: 1, background: C.border, margin: "24px 0 22px" };
